import {
  AHIcon,
  AHTextFonts,
  Box,
  TouchableBox,
  useLayoutContext,
  useTheme,
} from "arkh";
import React, { useCallback, useRef } from "react";
import { useFocusEffect } from "@react-navigation/native";
import { TextInputProps, TextInput } from "react-native";

export const FILE_SCREEN_SEARCH_BAR_HEIGHT = 44;

export function FileScreenSearchBar({
  isSearching,
  onCancel,
  ...textInputProps
}: {
  isSearching: boolean;
  onCancel(): void;
} & TextInputProps) {
  const layout = useLayoutContext();
  const inputRef = useRef<TextInput>(null);
  useFocusEffect(
    React.useCallback(() => {
      return () => {
        (inputRef.current as any)?.blur();
      };
    }, [inputRef])
  );
  const clear = useCallback(() => {
    textInputProps.onChangeText?.("");
  }, [textInputProps]);
  const theme = useTheme();
  return (
    <Box
      style={{
        height: FILE_SCREEN_SEARCH_BAR_HEIGHT,
        flexDirection: "row",
        alignItems: "center",
      }}
      spaceHorizontal="medium"
    >
      {isSearching ? (
        <TouchableBox
          onPress={onCancel}
          hitSlop={{ top: 20, bottom: 20, left: 20, right: 20 }}
          pressRetentionOffset={{ top: 20, bottom: 20, left: 20, right: 20 }}
        >
          <AHIcon type="chevron-left" color="darkerText" size="xlarge" />
        </TouchableBox>
      ) : null}
      <TextInput
        ref={inputRef as any}
        hitSlop={{ top: 20, bottom: 20, right: 20 }}
        style={{
          flex: 1,
          height: FILE_SCREEN_SEARCH_BAR_HEIGHT,
          paddingHorizontal: layout.space.medium,
          fontFamily: AHTextFonts.REGULAR,
          fontSize: layout.text.smallTitle,
        }}
        placeholderTextColor={theme.washedText}
        {...textInputProps}
      />
      {isSearching && (textInputProps.value?.length ?? 0) > 0 ? (
        <TouchableBox
          onPress={clear}
          hitSlop={{ top: 20, bottom: 20, left: 20, right: 20 }}
          pressRetentionOffset={{ top: 20, bottom: 20, left: 20, right: 20 }}
        >
          <AHIcon type="clear" customColor={theme.darkerText} forceSize={18} />
        </TouchableBox>
      ) : null}
    </Box>
  );
}
